import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "112",
  height: "112",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M56 2c29.823 0 54 24.177 54 54s-24.177 54-54 54S2 85.823 2 56 26.177 2 56 2zM26.998 60.94H22.5c2.156 14.746 13.816 26.405 28.562 28.56v-4.498l-.528-.094A29.281 29.281 0 0 1 35.199 76.8a29.283 29.283 0 0 1-8.201-15.861zm58.004 0-.094.527A29.281 29.281 0 0 1 76.8 76.801a29.283 29.283 0 0 1-15.861 8.201V89.5c14.745-2.156 26.404-13.815 28.56-28.56h-4.498zM56 43.85c-6.71 0-12.15 5.44-12.15 12.15S49.29 68.15 56 68.15 68.15 62.71 68.15 56 62.71 43.85 56 43.85zm4.94-21.35v4.498l.527.094A29.281 29.281 0 0 1 76.801 35.2a29.283 29.283 0 0 1 8.201 15.862H89.5c-2.155-14.745-13.814-26.405-28.56-28.56zm-9.878 0C36.315 24.655 24.655 36.315 22.5 51.062h4.498l.094-.528A29.281 29.281 0 0 1 35.2 35.199a29.283 29.283 0 0 1 15.862-8.201z",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }